<!-- 填空题 -->
<template>
  <div class="topic_choice">
    <div class="flex topic_select">
      <!-- <div class="topic_type">{{ questionTypeName }}</div> -->
      <div class="topic_content scroll_x mar_left_10 flex-1">
        <div class="topic_title" v-html="topicInfo?.questionTitle" v-mathml></div>
        <div class="flex Flexalign mt-15" v-if="getAudioUrl(topicInfo.otherRule)">
          <div class="mr-10">音频：</div>
          <audio :src="getAudioUrl(topicInfo.otherRule)" controls></audio>
        </div>
        <div class="mt-10">
          <!-- <el-radio-group row> -->
          <div v-for="(item, index) in topicInfo.questionContext?.options" :key="index">
            <!-- <el-radio :value="item.serial" size="large" :disabled="true"> -->
            <div class="flex Flexalign">
              <div>{{ item.label }} .</div>
              <div v-html="$Tools.handlerImg(item.content)" v-mathml></div>
            </div>
            <!-- </el-radio> -->
          </div>
          <!-- </el-radio-group> -->
        </div>
        <div v-if="!(testExamTime.remainingTime <= 0 ||
          isShowScoring ||
          topicInfo.showAnalysis)">
          <div class="mt-20">请按填空顺序选择你的答案</div>
          <div class="answer_one mt-15" v-for="(item, index) in topicInfo?.doOptions" :key="index">
            {{ index + 1 }}、<el-select v-model="item.doAnswer" placeholder="请选择你的答案" style="width: 240px"
              @change="getScore(item)">
              <el-option v-for="sitem in topicInfo.questionContext?.options" :key="sitem.serial" :label="sitem.label"
                :value="sitem.label" :disabled="testExamTime.remainingTime <= 0 ||
                  isShowScoring ||
                  topicInfo.showAnalysis
                  " />
            </el-select>
          </div>
        </div>
      </div>
    </div>
    <!-- <div v-if="!testType">
      <div class="topic_answer mt-20" v-if="isShowScoring || topicInfo.showAnalysis">
        <div class="answer_top p-20">
          <div>答题结果</div>
          <div class="flex FlexBetween mt-20">
            <div>
              <div>参考答案：</div>
              <div>{{ topicInfo.questionContext?.answer }}</div>
            </div>
            <div class="mar_left_20" v-if="!hideUserAnswer">
              <div class="user_answer">你的答案：
                <div class="bg_line"></div>
              </div>
              <div>{{ topicInfo.questionContext?.doAnswer }}</div>
            </div>
            <div class="mar_left_20 flex">
              <div class="full_score">
                <el-image class="question_error_icon" :src="iconPath('question_error_icon.png')"
                  v-if="topicInfo.isCorrect == 2"></el-image>
                <el-image class="question_error_icon" :src="iconPath('question_correct_icon.png')"
                  v-if="topicInfo.isCorrect == 1"></el-image>
              </div>
              <div class="get_score ml-10" v-if="!hideUserAnswer">
                得分：{{ topicInfo.score || 0 }}
              </div>
            </div>
          </div>
        </div>
        <div class="answer_top p-20 mt-20">
          <div class="question_analyze mar_top_10">【试题分析】</div>
          <div class="mar_top_10" v-html="$Tools.handlerImg(topicInfo.questionAnalyze)"></div>
          <div class="question_analyze mar_top_10">【解析】</div>
          <div class="mar_top_10" v-html="$Tools.handlerImg(topicInfo.questionExplanation)"></div>
        </div>
      </div>
    </div> -->
    <div>
      <div class="topic_answer mt-20" v-if="isShowScoring || topicInfo.showAnalysis">
        <div class="answer_top p-20" v-if="getIsShow(1) || showAnswer">
          <div>答题结果</div>
          <div class="flex FlexBetween mt-20">
            <div>
              <div>参考答案：</div>
              <div>{{ topicInfo.questionContext?.answer }}</div>
            </div>
            <div class="mar_left_20" v-if="!hideUserAnswer">
              <div class="user_answer">你的答案：
                <div class="bg_line"></div>
              </div>
              <div>{{ topicInfo.questionContext?.doAnswer }}</div>
            </div>
            <div class="mar_left_20 flex">
              <div class="full_score">
                <el-image class="question_error_icon" :src="iconPath('question_error_icon.png')"
                  v-if="topicInfo.isCorrect == 2"></el-image>
                <el-image class="question_error_icon" :src="iconPath('question_correct_icon.png')"
                  v-if="topicInfo.isCorrect == 1"></el-image>
              </div>
              <div class="get_score ml-10" v-if="!hideUserAnswer">
                得分：{{ topicInfo.questionScore }}
              </div>
            </div>
          </div>
          <!-- <div class="btn_ask">提问</div> -->
        </div>
        <div class="answer_top p-20 mt-20" v-if="getIsShow(2) || getIsShow(3) || showAnswer">
          <div class="question_analyze mar_top_10" v-if="getIsShow(2) || showAnswer">【试题分析】</div>
          <div class="mar_top_10" v-html="$Tools.handlerImg(topicInfo.questionAnalyze)" v-if="getIsShow(2) || showAnswer" v-mathml></div>
          <div class="question_analyze mar_top_10" v-if="getIsShow(3) || showAnswer">【解析】</div>
          <div class="mar_top_10" v-html="$Tools.handlerImg(topicInfo.questionExplanation)" v-if="getIsShow(3) || showAnswer" v-mathml></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import quillEditor from "@/components/quillEditor/index.vue"
import { mapState } from "vuex";
export default {
  name: "GjkcH5Choice",
  // components:{quillEditor},
  props: {
    questionInfo: {},
    isShowScoring: {
      default: false,
    },
    questionTypeName: {
      default: "填空题",
    },
    testType: {},
    //  用于错题展示隐藏用户答案信息等
    hideUserAnswer: {
      default: false,
    },
    isChallenge: {},
        showAnswer:{}, // 用于测评报告弹题展示解析等
  },
  computed: {
    ...mapState({
      testExamTime: (state) => state.exam.testExamTime,
      testExamInfo: (state) => state.exam.testExamInfo,
    }),
  },

  data() {
    return {
      topicInfo: {},
    };
  },
  watch: {
    questionInfo: {
      handler(val) {
        if (val) {
          this.topicInfo = this.questionInfo;
          // 判断是否回答过
          if (this.topicInfo.courseExamRecordId) {
            this.topicInfo.doAnswer = this.topicInfo.questionContext.doAnswer;
          }
        }
      },
      deep: true,
      immediate: true,
    },
  },

  mounted() {
    this.setRecordTimeInterval();
  },
  beforeUnmount() {
    if (this.recordTimeInterval) {
      clearInterval(this.recordTimeInterval);
      this.recordTimeInterval = null;
    }
  },

  methods: {
    setRecordTimeInterval() {
      if (!this.$Tools.empty(this.testExamInfo.otherRule)) {
        this.recordTimeInterval = setInterval(() => {
          if (this.topicInfo.answerSection == null) {
            this.topicInfo.answerSection = 1;
          } else {
            this.topicInfo.answerSection++;
          }
          // 按每题作答时间提交
          if (this.testExamInfo.otherRule.timeType == 2) {
            this.$emit("answerQuestion", this.topicInfo);
            // 当作答时间超过设定时间，该题设置为已完成并且不给作答
            if (
              this.topicInfo.answerSection >=
              this.testExamInfo.otherRule.perQuestionTime
            ) {
              this.topicInfo.questionContext.isFinish = true;
              this.$emit("answerQuestion", this.topicInfo);
              setTimeout(() => {
                this.$emit("showAnalysis", true);
              }, 1000)
              if (this.recordTimeInterval) {
                clearInterval(this.recordTimeInterval);
                this.recordTimeInterval = null;
              }
            }
          }
          // 判断当提交后定时器关闭 
          else if (this.isShowScoring || this.topicInfo.showAnalysis) {
            if (this.recordTimeInterval) {
              clearInterval(this.recordTimeInterval);
              this.recordTimeInterval = null;
            }
          }
        }, 1000);
      }
    },
    getIsShow(showId) {
      let flag = false;
      if (!this.$Tools.empty(this.testExamInfo.otherRule)) {
        if (!this.$Tools.empty(this.testExamInfo.otherRule.showAnswer)) {
          if (this.testExamInfo.otherRule.showAnswer.findIndex(item => item == showId) != -1) {
            flag = true;
          }
        }
      }
      return flag
    },
    getAudioUrl(info) {
      let ruleInfo = this.$Tools.jsonDecode(info);
      if (!this.$Tools.empty(ruleInfo)) {
        return ruleInfo.listeningRule?.audioUrl;
      }
    },
    getScore() {
      this.topicInfo.questionScore = 0;
      this.topicInfo.questionContext.isFinish = false;
      this.topicInfo.questionContext.doAnswer = "";
      this.topicInfo?.doOptions.forEach((item) => {
        // if (item.doAnswer == item.content) {
        //   this.topicInfo.questionScore += Number(item.singleScore); // 得分
        // }
        // 有答案则已完成
        if (!this.$Tools.empty(item.doAnswer)) {
          this.topicInfo.questionContext.isFinish = true;
          this.topicInfo.questionContext.doAnswer += item.doAnswer + ",";
        }
      });
      this.topicInfo.questionContext.doAnswer =
        this.topicInfo.questionContext.doAnswer.slice(0, -1);
      if (
        this.topicInfo.questionContext.doAnswer ==
        this.topicInfo.questionContext.answer
      ) {
        this.topicInfo.questionScore = this.topicInfo.questionContext.score;
        this.topicInfo.isCorrect = 1;
      } else {
        this.topicInfo.isCorrect = 2;
      }
      // this.topicInfo.questionContext.isFinish = !this.$Tools.empty(this.topicInfo.questionContext.doAnswer);   // 是否已完成
      this.$emit("answerQuestion", this.topicInfo);
    },
  },
};
</script>

<style lang="scss" scoped>
.topic_select {
  .topic_type {
    // margin-top: 1rem;
    min-width: 45px;
    padding: 0 8px;
    height: 21px;
    background: rgba(0, 199, 88, 0.2);
    border-radius: 4px;
    border: 1px solid #00c758;
    line-height: 21px;
    text-align: center;
    font-size: 12px;
    color: #00c758;
  }

  .topic_content {
    // overflow-x: auto;

    .topic_title {
      font-size: 16px;
      color: #242324;
      font-weight: 600;
    }
  }
}

.bottom_box {
  position: absolute;
  left: calc(50% - 60px);
  bottom: 40px;
  text-align: center;

  .btn_view {
    width: 120px;
    height: 42px;
    background: linear-gradient(90deg, #00d5c2, #00d498);
    border-radius: 21px;
    text-align: center;
    line-height: 42px;
    color: #fff;
    font-size: 18px;
  }

  .view_analysis {
    color: #13d6aa;
  }
}

.topic_answer {
  width: 100%;
  // height: 222px;
  // background: rgba(19, 214, 170, 0.05);
  border-radius: 10px;
  // padding: 20px;
  color: #666666;
  box-sizing: border-box;

  .answer_top {
    background: #F8F9FA;
    border-radius: 8px;
    width: 100%;
    box-sizing: border-box;

    .user_answer {
      position: relative;

      .bg_line {
        width: 73px;
        height: 8px;
        background: rgba(19, 214, 170, 0.2);
        position: absolute;
        top: 16px;
        left: 0;
      }
    }

    .question_error_icon {
      width: 26px;
      height: 26px;
    }

    .error_value_answer {
      color: RGBA(255, 49, 49, 1);
    }

    .correct_value_answer {
      color: RGBA(0, 199, 88, 1);
    }

    .btn_ask {
      width: 64px;
      height: 28px;
      background: linear-gradient(90deg, #00d5c2, #00d498);
      border-radius: 14px;
      line-height: 28px;
      text-align: center;
      color: #fff;
    }

    .get_score {
      color: #fd673b;
    }
  }

  .question_analyze {
    color: #333333;
    font-weight: 600;
  }
}
</style>